export default __webpack_public_path__ + "static/media/letherman.19e525c6.jpg";